/* eslint-disable import/no-anonymous-default-export */
import axios from './BASE_API'
import AuthHeader from './AuthHeader'

// class define
class PackageSubscriptionAPI {

  subscribeNewPackage: any = (packageId: number) => {
    return axios.post('/subscribed-package/subscribe-new-package', { package_id: packageId }, {headers: AuthHeader()})
  }
  
  verifyPayment: any = (reference: string) => {
    return axios.post('/subscribed-package/verify-payment', { reference_id: reference }, {headers: AuthHeader()})
    }
    
}

export default new PackageSubscriptionAPI()
